import React from "react";
import { useParams } from "react-router-dom";

// Sample Data Object (You can move this to a separate file later)
const eventsData = [
  {
    id: 1,
    slug: "msme-award-2025",
    title: "LifeOnPlus Founder & CEO Honored with Star MSME Award 2025",
    date: "18th August 2025",
    venue: "Le Meridien, New Delhi",
    heroImage: "/news/13.jpg",

    description: `We are proud to announce that our Founder & CEO, Mr. Rajanikant M. Torgal, has been conferred with the Star MSME Award 2025 at the prestigious International MSME Business Conclave 5.0, held on 18th August 2025 at Le Meridien, New Delhi.

The award was presented by Mrs. Hema Malini (Hon. Member of Parliament & Actress) in the presence of eminent leaders, global delegates, policymakers, and industry veterans.`,

    purpose: [
      "The Star MSME Awards are among the most prestigious recognitions in the MSME sector.",
      "Our accomplishments get visible across the industry.",
      "To Set benchmarks against industry peers, showcasing innovation and resilience.",
      "To Mark our spot in history with recognition among the best in MSMEs.",
      "Provides extensive media coverage across print and digital platforms, before and after the event.",
    ],

    highlights: [
      "2,500+ Business Leaders & MSMEs",
      "30+ Government & Industry Speakers",
      "150+ MSME Categories of Recognition",
      "Global Trade Ambassadors Panel",
      "Live Media & Multi-Channel Coverage",
      "International Delegations from 10+ Countries",
    ],

    milestone: `This award marks a significant milestone in the journey of LifeOnPlus – a Digital Health Ecosystem built to make healthcare affordable, accessible, and technology-driven.

It reflects our Founder’s vision to bridge healthcare gaps globally while empowering MSMEs through innovation and collaboration.

We dedicate this recognition to our entire team, partners, and stakeholders, whose efforts have contributed to making this achievement possible.

With this honor, LifeOnPlus is more determined than ever to continue its mission of creating impactful, sustainable, and global healthcare solutions.`,
    gallery: [
      "/news/1.jpg",
      "/news/3.jpg",
      "/news/4.jpg",
      "/news/5.jpg",
      "/news/6.jpg",
      "/news/7.jpg",
      "/news/8.jpg",
      "/news/9.jpg",
      "/news/10.jpg",
      "/news/11.jpg",
      "/news/14.jpg",
    ],
  },
  {
    id: 2,
    slug: "brainstorm-ai-singapore-2025",
    title: "Brainstorm AI Singapore 2025",
    date: "22-23 July 2025",
    venue: "The Ritz Carlton, Millenia, Singapore",
    heroImage: "/news/brainstorm.jpg",

    description: `The Age of Intelligence — exploring AI's shift from perception to reasoning, planning, and action.`,

    keynote:
      "Global leader forum. Over 60 speakers convened, including C suite executives, government ministers, technologists, visionaries like Refik Anadol, and policy pioneers.",

    focusAreas: [
      "AI-powered agents enhancing enterprise productivity",
      "Integration across banking, gaming, healthcare, sustainability",
      "Ethical deployment, regulatory frameworks, and energy-efficient infrastructures",
    ],

    notableSpeakers: [
      "Josephine Teo, Minister for Digital Development & Information, Singapore",
      "Tan Su Shan, Group CEO, DBS Bank",
      "Oliver Jay, Managing Director, OpenAI International",
      "Refik Anadol (artist)",
    ],

    contributions: `Mr. Rajanikant M. Torgal's Contributions:
Engaged in multiple sessions, interacting with speakers to explore AI applications across diverse sectors. Gained insights into emerging opportunities in finance, sustainability, urban planning, and enterprise operations.`,

    takeaways: [
      "Strategic AI deployment: Real-world case studies emphasized moving from concept to implementation with responsibility and impact.",
      "Cross sector potential: AI's role in reshaping industries like banking, health, gaming, and climate tech.",
      "Ethics & Sustainability: Key panels addressed energy consumption and the need for regulation-driven scalability.",
    ],
    gallery: [
      "/news/1-1.jpg",
      "/news/2.jpg",
      "/news/2-1.jpg",
      "/news/3-1.jpg",
      "/news/4-1.jpg",
      "/news/5-1.jpg",
      "/news/6-1.jpg",
      "/news/7-1.jpg",
      "/news/8-1.jpg",
    ],
  },
  {
    id: 3,
    slug: "business-frontier-dubai-2025",
    title: "Upcoming Event Business Frontier Leadership Conclave & Awards",
    date: "25th April 2025",
    venue: "Le Méridien Dubai Hotel & Conference Centre, Al Garhoud, Dubai",
    heroImage: "/news/awards1.jpg",

    description: `We are excited to announce our participation in the Business Frontier Leadership Conclave & Awards, set to take place on 25th April 2025 at Le Méridien Dubai Hotel & Conference Centre, Al Garhoud, Dubai.\n\nA highlight of the event is the power-packed panel discussion on "The Future of Leadership in the Age of AI & Automation." Esteemed thought leaders including Dr. Mina Al Hosani, Rashmi Horen, Dr. Afra Al Basti, Vanjula Kaul, and Yogita Tulsiani will explore how AI and automation are reshaping leadership in today’s dynamic world.\n\nThe session will be moderated by Sanjeev Kumar, Founder & Chief Visionary Officer of Harley Street Healthcare Group.`,

    highlights: [
      "Panel Discussion: The Future of Leadership in the Age of AI & Automation",
      "Moderator: Sanjeev Kumar",
      "Panelists: Dr. Mina Al Hosani, Rashmi Horen, Dr. Afra Al Basti, Vanjula Kaul, Yogita Tulsiani",
      "Focus on leadership transformation in AI era",
    ],
    gallery: [],
  },
];

const NewsEventDetail = () => {
  // Find event by slug or id
  const { id } = useParams();

  const event = eventsData.find((item) => item.id === parseInt(id));

  // If event not found
  if (!event) {
    return (
      <div className="text-center py-20">
        <h2 className="text-3xl font-bold text-red-600">Event Not Found</h2>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <h1 className="text-2xl md:text-3xl font-bold text-center text-green-700 mb-8">
        {event.title}
      </h1>

      <p className="text-center text-gray-600 text-xl mb-10">
        {event.date} • {event.venue}
      </p>

      <div className="mb-12 rounded-2xl overflow-hidden shadow-2xl">
        <img src={event.heroImage} alt={event.title} className="w-full" />
      </div>

      <div className="prose prose-lg max-w-none mb-12 text-gray-800 whitespace-pre-line">
        {event.description}
      </div>

      {/* Dynamic Sections */}
      {event.purpose && (
        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-green-700 mb-6">
            Purpose & Importance of the Award
          </h2>
          <ol className="list-decimal pl-6 space-y-3 text-gray-700">
            {event.purpose.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ol>
        </section>
      )}

      {event.keynote && (
        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-green-700 mb-4">
            Keynote & Featured Sessions
          </h2>
          <p>{event.keynote}</p>
        </section>
      )}

      {event.focusAreas && (
        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-green-700 mb-4">
            Focus Areas
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            {event.focusAreas.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </section>
      )}

      {event.notableSpeakers && (
        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-green-700 mb-4">
            Notable Speakers
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            {event.notableSpeakers.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </section>
      )}

      {event.contributions && (
        <section className="mb-10 bg-gray-50 p-6 rounded-xl">
          <h2 className="text-2xl font-semibold text-green-700 mb-4">
            Mr. Rajanikant M. Torgal's Contributions
          </h2>
          <p className="whitespace-pre-line">{event.contributions}</p>
        </section>
      )}

      {event.takeaways && (
        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-green-700 mb-4">
            Strategic Takeaways
          </h2>
          <ul className="list-decimal pl-6 space-y-3">
            {event.takeaways.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </section>
      )}

      {event.highlights && (
        <section className="mb-12">
          <h2 className="text-2xl font-semibold text-green-700 mb-6">
            Highlights
          </h2>
          <ul className="list-disc pl-6 space-y-3 text-gray-700">
            {event.highlights.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </section>
      )}

      {event.milestone && (
        <section className="bg-green-50 border-l-4 border-green-600 p-8 rounded-r-xl mb-12">
          <h3 className="text-2xl font-semibold text-green-800 mb-4">
            A Milestone for LifeOnPlus
          </h3>
          <p className="whitespace-pre-line">{event.milestone}</p>
        </section>
      )}

      {/* Gallery */}
      {event.gallery && event.gallery.length > 0 && (
        <section>
          <h2 className="text-2xl font-semibold text-green-700 mb-8 text-center">
            Event Gallery
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {event.gallery.map((img, index) => (
              <div key={index} className="rounded-xl overflow-hidden shadow-lg">
                <img
                  src={img}
                  alt={`Event ${index + 1}`}
                  className="w-full h-64 object-contain hover:scale-105 transition-transform"
                />
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default NewsEventDetail;
